import { NavigationLink } from 'components/NavigationLink';
import { GlobalClasses, lodash } from 'helpers';
import { TranslationPath, useTranslation } from 'libs/i18n';
import { ROUTES } from 'libs/navigation';
import { useUser } from 'libs/providers';
import { Typography } from 'libs/ui';

import { ContainerStyled } from './NavigationMenu.styles';

interface MenuType {
  title: TranslationPath;
  path: string;
}

const menu: MenuType[] = lodash.compact([
  {
    title: 'menu.orders',
    path: ROUTES.account.orders.fullPath,
  },
]);

export const NavigationMenu = () => {
  const { t } = useTranslation();

  const { user } = useUser();

  if (!user) {
    return null;
  }

  return (
    <ContainerStyled alignItems="center" as="nav" direction="row" spacing={48}>
      {menu.map((v) => (
        <NavigationLink
          key={v.path}
          className={GlobalClasses.hoveredChild}
          to={v.path}
        >
          <Typography
            className="navigationMenu-link"
            variant="bodyMedium"
            variantMobile="captionMedium"
          >
            {t(v.title) as string}
          </Typography>
        </NavigationLink>
      ))}
    </ContainerStyled>
  );
};
